<template>
  <div class="tree-node">
    <!-- سطر سرفصل -->
    <div class="tree-row">
      <div class="toggle-icon" @click="isOpen = !isOpen">
        <i
          v-if="chapter.media && chapter.media.length"
          :class="isOpen ? 'bi bi-chevron-down' : 'bi bi-chevron-left'"
        ></i>
        <i v-else class="bi bi-dot"></i>
      </div>

      <div class="category-info">
        <i class="bi bi-folder2-open text-primary me-2"></i>
        <span class="category-title"
          >{{ chapter.name_fa }} / {{ chapter.name_en }}</span
        >
      </div>

      <div class="actions">
        <button
          class="btn-action add"
          :title="currentLang.btnAddMedia"
          @click="$emit('add-media', chapter.id)"
        >
          <i class="bi bi-plus"></i>
        </button>
        <button
          class="btn-action edit"
          :title="currentLang.btnEditChapter"
          @click="$emit('edit-chapter', chapter)"
        >
          <i class="bi bi-pencil"></i>
        </button>
        <button
          class="btn-action delete"
          :title="currentLang.btnDelete"
          @click="handleDeleteChapter(chapter.id)"
        >
          <i class="bi bi-trash"></i>
        </button>
      </div>
    </div>

    <!-- لیست مدیاها (فرزندها) -->
    <div
      v-if="isOpen && chapter.media && chapter.media.length"
      class="children-wrapper"
    >
      <div
        v-for="media in chapter.media"
        :key="media.id"
        class="tree-row media-row"
      >
        <div class="toggle-icon"><i class="bi bi-file-earmark-play"></i></div>
        <div class="category-info">
          {{ media.title }} <small class="text-muted">({{ media.type }})</small>
        </div>
        <div class="actions">
          <button
            class="btn-action edit"
            :title="currentLang.btnEditMedia"
            @click="$emit('edit-media', { media, chapterId: chapter.id })"
          >
            <i class="bi bi-pencil"></i>
          </button>

            <button
          class="btn-action delete"
          :title="currentLang.btnDelete"
          @click="handleDeleteMedia(media.id)"
        >
          <i class="bi bi-trash"></i>
        </button>

          
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { lang } from "@/plugins/lang";
import api from "@/plugins/axios";
import enText from "@/locales/en/chapters";
import faText from "@/locales/fa/chapters";
import { alertStore } from "@/stores/alertStore";

const translations = { en: enText, fa: faText };
const currentLang = computed(() => translations[lang.value]);
/* eslint-enable no-undef */

defineProps({ chapter: Object });
const emit = defineEmits(["refresh", "edit-chapter", "add-media", "edit-media"]);

const isOpen = ref(true);



const handleDeleteChapter = async (id) => {
  if (!confirm(currentLang.value.deleteConfirm)) return;

  try {
    const response = await api.delete(`/admin/products/chapter/${id}`);

    if (response.status === 200) {
      alertStore.trigger("success",currentLang.value.success, response.data.message);
      emit("refresh");
        }

     else {
      alertStore.trigger("error",currentLang.value.error, response.data.message);
    }
  } catch (e) {
    alert(e);
  }
};




const handleDeleteMedia = async (id) => {
  if (!confirm(currentLang.value.deleteConfirm)) return;

  try {
    const response = await api.delete(`/admin/products/chapter/${id}/media`);

    if (response.status === 200) {
      alertStore.trigger("success",currentLang.value.success, response.data.message);
      emit("refresh");
        }

     else {
      alertStore.trigger("error",currentLang.value.error, response.data.message);
    }
  } catch (e) {
    alert(e);
  }
};
</script>

<style scoped>
/* استفاده از همان استایل‌های CategoryItem که فرستادی */
.tree-node {
  margin-top: 4px;
}
.tree-row {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background: #fdfdfd;
  border: 1px solid #f1f1f1;
  border-radius: 10px;
  transition: 0.2s;
  margin-bottom: 4px;
}
.tree-row:hover {
  background: #f8fafc;
  border-color: #e2e8f0;
}
.media-row {
  background: #fff !important;
  border: 1px solid #f8fafc;
  margin-top: 2px;
}

.toggle-icon {
  width: 25px;
  cursor: pointer;
  color: #64748b;
}
.category-info {
  flex-grow: 1;
  font-weight: 500;
  color: #1e293b;
}
.children-wrapper {
  margin-right: 25px;
  border-right: 1px dashed #cbd5e1;
  padding-right: 10px;
}

.actions {
  display: flex;
  gap: 8px;
}
.btn-action {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}
.btn-action.add {
  background: #f0fdf4;
  color: #16a34a;
}
.btn-action.edit {
  background: #eff6ff;
  color: #2563eb;
}
.btn-action:hover {
  transform: scale(1.1);
}
.btn-action.delete {
  background: #fef2f2;
  color: #dc2626;
}
</style>
